 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth~editor":"auth~editor","auth~my-area":"auth~my-area","auth":"auth","my-area":"my-area","admin":"admin","editor":"editor","testimonials":"testimonials","china":"china"}[chunkId]||chunkId) + "." + {"chunk-0039edb4":"471ca3fc","chunk-0df3360c":"b8380d03","chunk-15195ae8":"c32cb194","chunk-24170130":"6ebf9220","chunk-0ca75abc":"3c6a2425","chunk-4b178509":"df56b8ec","chunk-2bdc10cf":"b5e13e99","chunk-2d0e5e97":"85be14f7","chunk-2d20ef97":"49ea694b","chunk-2d2223b5":"6f5a75f3","chunk-2d22d053":"bba7731c","chunk-31358fd8":"7a041dbf","chunk-313887fa":"3251f0ee","chunk-36cf424f":"6a822a05","chunk-0702f8ba":"7ca020f7","chunk-2b98ab17":"7a1dedf9","chunk-3a52ec36":"864da739","chunk-9901eb78":"0b513a63","chunk-f01dc74e":"f11392a4","chunk-5b71b6d0":"e02e92d6","chunk-5c229159":"c7289ed7","chunk-5ee22d3d":"54d58bb6","chunk-63a5702f":"19c5ec29","chunk-63c81c8d":"be77ccfc","chunk-0ab2cfd3":"e821d952","auth~editor":"9db6e4fd","auth~my-area":"cbde062d","auth":"5000f9a3","my-area":"b74f4c41","chunk-2303c611":"5e4de3b2","chunk-2e94db89":"d704900a","chunk-36af0d76":"2a3f6939","chunk-dadc426a":"fd98e43c","chunk-ce920e50":"90ddaada","chunk-68e1902e":"8a427b7c","chunk-ca9a1bb0":"2dc79041","chunk-ec3aacc2":"0e38f317","chunk-5edbfe54":"b80fbe67","chunk-a74b4588":"e0b7972f","admin":"09f0a032","chunk-3bc19e01":"7d8f2d8c","chunk-55902d2c":"ce6a1e8c","chunk-5d07f856":"4231e3aa","chunk-a3b1bf36":"b88a0a47","chunk-211cb2cc":"bc26ea06","chunk-68fff302":"c2585355","chunk-2ee06b0c":"3791e942","chunk-957af7ca":"b2aaeee3","editor":"5d49bf39","testimonials":"91964eab","china":"4e5e9131","chunk-e1810938":"98abacf4","chunk-2cf1c3bc":"149b6207"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-0039edb4":1,"chunk-0df3360c":1,"chunk-15195ae8":1,"chunk-24170130":1,"chunk-0ca75abc":1,"chunk-4b178509":1,"chunk-2bdc10cf":1,"chunk-31358fd8":1,"chunk-313887fa":1,"chunk-36cf424f":1,"chunk-0702f8ba":1,"chunk-2b98ab17":1,"chunk-3a52ec36":1,"chunk-9901eb78":1,"chunk-f01dc74e":1,"chunk-5b71b6d0":1,"chunk-5c229159":1,"chunk-5ee22d3d":1,"chunk-63a5702f":1,"chunk-0ab2cfd3":1,"auth~my-area":1,"auth":1,"my-area":1,"chunk-2303c611":1,"chunk-2e94db89":1,"chunk-36af0d76":1,"chunk-dadc426a":1,"chunk-ce920e50":1,"chunk-68e1902e":1,"chunk-ca9a1bb0":1,"chunk-ec3aacc2":1,"chunk-5edbfe54":1,"chunk-a74b4588":1,"admin":1,"chunk-3bc19e01":1,"chunk-55902d2c":1,"chunk-5d07f856":1,"chunk-a3b1bf36":1,"chunk-211cb2cc":1,"chunk-68fff302":1,"chunk-2ee06b0c":1,"chunk-957af7ca":1,"editor":1,"testimonials":1,"china":1,"chunk-e1810938":1,"chunk-2cf1c3bc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth~editor":"auth~editor","auth~my-area":"auth~my-area","auth":"auth","my-area":"my-area","admin":"admin","editor":"editor","testimonials":"testimonials","china":"china"}[chunkId]||chunkId) + "." + {"chunk-0039edb4":"60f12781","chunk-0df3360c":"57c3ed28","chunk-15195ae8":"c082e16a","chunk-24170130":"842b9b3f","chunk-0ca75abc":"1c1860a2","chunk-4b178509":"eb7bd656","chunk-2bdc10cf":"9bbaea70","chunk-2d0e5e97":"31d6cfe0","chunk-2d20ef97":"31d6cfe0","chunk-2d2223b5":"31d6cfe0","chunk-2d22d053":"31d6cfe0","chunk-31358fd8":"ac3f23be","chunk-313887fa":"9caa7b41","chunk-36cf424f":"6795f0f4","chunk-0702f8ba":"89b33316","chunk-2b98ab17":"9e5da4a3","chunk-3a52ec36":"18f728a6","chunk-9901eb78":"bd1f69f3","chunk-f01dc74e":"101543bb","chunk-5b71b6d0":"9caa7b41","chunk-5c229159":"9caa7b41","chunk-5ee22d3d":"9bbe0269","chunk-63a5702f":"4ae3be66","chunk-63c81c8d":"31d6cfe0","chunk-0ab2cfd3":"ae24d3e6","auth~editor":"31d6cfe0","auth~my-area":"5e3b23a8","auth":"26bf4ef7","my-area":"16a3c839","chunk-2303c611":"56c60f0a","chunk-2e94db89":"920f1f7d","chunk-36af0d76":"ee310c86","chunk-dadc426a":"b98d3ddb","chunk-ce920e50":"e328c13a","chunk-68e1902e":"7570fc7d","chunk-ca9a1bb0":"040819b0","chunk-ec3aacc2":"86996bed","chunk-5edbfe54":"578e03a8","chunk-a74b4588":"76374ef3","admin":"a442a790","chunk-3bc19e01":"56a5609c","chunk-55902d2c":"fd172b6d","chunk-5d07f856":"2b83db89","chunk-a3b1bf36":"940931a8","chunk-211cb2cc":"62e4bafa","chunk-68fff302":"babc3a1d","chunk-2ee06b0c":"00aae252","chunk-957af7ca":"e8fb4a62","editor":"1fb02e7d","testimonials":"114c8711","china":"6fef1961","chunk-e1810938":"833cd6ce","chunk-2cf1c3bc":"4f4288b9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
